import React, { useState } from "react"
import { Link } from "react-router-dom"
import {
  Button,
  Card,
  Col,
  NavItem,
  Spinner,
  NavLink,
  Row,
  TabContent,
  TabPane,
} from "reactstrap"

import classnames from "classnames"

//import images
import small from "../../../assets/images/small/img-2.jpg"
import small2 from "../../../assets/images/small/img-6.jpg"
import { getJournals } from "helpers/fakebackend_helper"
import { useQuery } from "react-query"
import CenterModal from "components/Common/CenterModal"
import JournalCreateFrom from "components/Journal/JournalCreateFrom"
import { IMAGE_BASE_URL } from "constants/imageUrl"

const BlogList = () => {
  const [activeTab, toggleTab] = useState("1");

  const { data, isLoading, refetch } = useQuery(
    "journal_list",
    getJournals,
    {
      staleTime: 60000,
      refetchOnWindowFocus: false,
      refetchOnMount: false,
    }
  )

  const [isOpen, setIsOpen] = useState(false)
  const toggleModal = () => setIsOpen(!isOpen)

  const closeModal = () => {
    setIsOpen(false)
    refetch()
  }

  return (
    <React.Fragment>
      <Col xl={12} lg={12}>
        <Card>
          {/* <ul
            className="nav nav-tabs nav-tabs-custom justify-content-center pt-2"
            role="tablist"
          >
            <NavItem>
              <NavLink
                to="#"
                className={classnames({
                  active: activeTab === "1",
                })}
                onClick={() => {
                  toggleTab("1")
                }}
              >
                All Post
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                to="#"
                className={classnames({
                  active: activeTab === "2",
                })}
                onClick={() => {
                  toggleTab("2")
                }}
              >
                Archive
              </NavLink>
            </NavItem>
          </ul> */}
          <div className="d-flex justify-content-end">
            <Button color="primary" style={{ backgroundColor: "#2F8C47" }} className="m-3" onClick={toggleModal}>
               Create Journal
            </Button>

            <CenterModal
              title="Create Journal"
              isOpen={isOpen}
              toggle={toggleModal}
            >
              <JournalCreateFrom closeModal={closeModal} />
            </CenterModal>
          </div>

          <TabContent className="p-4" activeTab={activeTab}>
            <TabPane tabId="1">
              <div>
                <Row className="justify-content-center">
                  <Col xl={8}>
                    <div>
                      <Row className="align-items-center">
                        {/* <Col xs={4}>
                          <div>
                            <h5 className="mb-0">Journals</h5>
                          </div>
                        </Col> */}

                        {/* <Col xs={8}>
                          <div className="float-end">
                            <ul className="nav nav-pills">
                              <NavItem>
                                <NavLink
                                  className="disabled"
                                  to="#"
                                  tabIndex="-1"
                                >
                                  View :
                                </NavLink>
                              </NavItem>
                              <NavItem>
                                <Link
                                  className="nav-link active"
                                  to="blog-list"
                                >
                                  <i className="mdi mdi-format-list-bulleted"></i>
                                </Link>
                              </NavItem>
                              <NavItem>
                                <Link to="blog-grid" className="nav-link">
                                  <i className="mdi mdi-view-grid-outline"></i>
                                </Link>
                              </NavItem>
                            </ul>
                          </div>
                        </Col> */}
                      </Row>

                      {/* <hr className="mb-4" /> */}

                      {isLoading ? (
                        <div className="d-flex justify-content-center">
                          <Spinner animation="border" role="status">
                            <span className="sr-only">Loading...</span>
                          </Spinner>
                        </div>
                      ) : data?.journals?.length === 0 ? ( // Check if there are no journals
                        <div className=" ">
                          <JournalCreateFrom closeModal={refetch}  />  
                        </div>  
                      ) : (
                        data?.journals?.map((journal) => (
                          <div key={journal.id}>
                            <h5>
                              <Link to={`journal-details/${journal.id}`} className="text-dark" style={{ fontSize: 'larger' }}>
                                {journal?.name?.charAt(0).toUpperCase() + journal?.name?.slice(1)}
                              </Link>
                            </h5>
                            <p className="text-muted">{new Date(journal.created_at).toLocaleDateString()}</p>

                            <div className="position-relative mb-3 my-5">
                              <img src={`${IMAGE_BASE_URL}/${journal?.journal_photos[0]?.photo_url}`} alt="" className="img-thumbnail"  />
                            </div>

                            <ul className="list-inline">
                              <li className="list-inline-item mr-3">
                                <Link to="#" className="text-muted">
                                  <i className="bx bx-map-pin align-middle text-muted me-1"></i>{" "}
                                  Location
                                </Link>
                              </li>
                              <li className="list-inline-item mr-3">
                                <Link to="#" className="text-muted">
                                  <i className="bx bx-user align-middle text-muted me-1"></i>{" "}
                                  {journal?.created_by?.name}
                                </Link>
                              </li>
                            </ul>
                            <p>
                              {journal?.content?.substring(0, 382)}
                            </p>

                            <div>
                              <Link to={`journal-details/${journal?.id}`} className="text-primary">
                                Read more <i className="mdi mdi-arrow-right"></i>
                              </Link>
                            </div>
                            <hr className="my-5" />

                          </div>
                        ))
                      )}




                      {/* <div className="text-center">
                        <ul className="pagination justify-content-center pagination-rounded">
                          <li className="page-item disabled">
                            <Link to="#" className="page-link">
                              <i className="mdi mdi-chevron-left"></i>
                            </Link>
                          </li>
                          <li className="page-item">
                            <Link to="#" className="page-link">
                              1
                            </Link>
                          </li>
                          <li className="page-item active">
                            <Link to="#" className="page-link">
                              2
                            </Link>
                          </li>
                          <li className="page-item">
                            <Link to="#" className="page-link">
                              3
                            </Link>
                          </li>
                          <li className="page-item">
                            <Link to="#" className="page-link">
                              ...
                            </Link>
                          </li>
                          <li className="page-item">
                            <Link to="#" className="page-link">
                              10
                            </Link>
                          </li>
                          <li className="page-item">
                            <Link to="#" className="page-link">
                              <i className="mdi mdi-chevron-right"></i>
                            </Link>
                          </li>
                        </ul>
                      </div> */}
                    </div>
                  </Col>
                </Row>
              </div>
            </TabPane>

            {/* <TabPane tabId="2">
              <div>
                <Row className="justify-content-center">
                  <Col xl={8}>
                    <h5>Archive</h5>

                    <div className="mt-5">
                      <div className="d-flex flex-wrap">
                        <div className="me-2">
                          <h4>2020</h4>
                        </div>
                        <div className="ms-auto">
                          <span className="badge badge-soft-success rounded-pill float-end ms-1 font-size-12">
                            03
                          </span>
                        </div>
                      </div>
                      <hr className="mt-2" />

                      <div className="list-group list-group-flush">
                        <Link
                          to="/blog-details"
                          className="list-group-item text-muted"
                        >
                          <i className="mdi mdi-circle-medium me-1"></i>{" "}
                          Beautiful Day with Friends
                        </Link>

                        <Link
                          to="/blog-details"
                          className="list-group-item text-muted"
                        >
                          <i className="mdi mdi-circle-medium me-1"></i> Drawing
                          a sketch
                        </Link>

                        <Link
                          to="/blog-details"
                          className="list-group-item text-muted"
                        >
                          <i className="mdi mdi-circle-medium me-1"></i> Project
                          discussion with team
                        </Link>
                      </div>
                    </div>

                    <div className="mt-5">
                      <div className="d-flex flex-wrap">
                        <div className="me-2">
                          <h4>2019</h4>
                        </div>
                        <div className="ms-auto">
                          <span className="badge badge-soft-success badge-pill float-right ms-1 font-size-12">
                            06
                          </span>
                        </div>
                      </div>
                      <hr className="mt-2" />

                      <div className="list-group list-group-flush">
                        <Link
                          to="/blog-details"
                          className="list-group-item text-muted"
                        >
                          <i className="mdi mdi-circle-medium me-1"></i> Coffee
                          with Friends
                        </Link>

                        <Link
                          to="/blog-details"
                          className="list-group-item text-muted"
                        >
                          <i className="mdi mdi-circle-medium me-1"></i> Neque
                          porro quisquam est
                        </Link>

                        <Link
                          to="/blog-details"
                          className="list-group-item text-muted"
                        >
                          <i className="mdi mdi-circle-medium me-1"></i> Quis
                          autem vel eum iure
                        </Link>

                        <Link
                          to="/blog-details"
                          className="list-group-item text-muted"
                        >
                          <i className="mdi mdi-circle-medium me-1"></i> Cras mi
                          eu turpis
                        </Link>

                        <Link
                          to="/blog-details"
                          className="list-group-item text-muted"
                        >
                          <i className="mdi mdi-circle-medium me-1"></i> Drawing
                          a sketch
                        </Link>

                        <Link
                          to="/blog-details"
                          className="list-group-item text-muted"
                        >
                          <i className="mdi mdi-circle-medium me-1"></i> Project
                          discussion with team
                        </Link>
                      </div>
                    </div>

                    <div className="mt-5">
                      <div className="d-flex flex-wrap">
                        <div className="me-2">
                          <h4>2018</h4>
                        </div>
                        <div className="ms-auto">
                          <span className="badge badge-soft-success rounded-pill float-end ms-1 font-size-12">
                            03
                          </span>
                        </div>
                      </div>
                      <hr className="mt-2" />

                      <div className="list-group list-group-flush">
                        <Link
                          to="/blog-details"
                          className="list-group-item text-muted"
                        >
                          <i className="mdi mdi-circle-medium me-1"></i>{" "}
                          Beautiful Day with Friends
                        </Link>

                        <Link
                          to="/blog-details"
                          className="list-group-item text-muted"
                        >
                          <i className="mdi mdi-circle-medium me-1"></i> Drawing
                          a sketch
                        </Link>

                        <Link
                          to="/blog-details"
                          className="list-group-item text-muted"
                        >
                          <i className="mdi mdi-circle-medium me-1"></i> Project
                          discussion with team
                        </Link>
                      </div>
                    </div>
                  </Col>
                </Row>
              </div>
            </TabPane> */}
          </TabContent>
        </Card>
      </Col>
    </React.Fragment>
  )
}

export default BlogList;